import { SET_VIDEO_CATEGORIES } from 'store/types/video-catergory';

export const setVideoCategories = (videoCategories) => {
  return {
    type: SET_VIDEO_CATEGORIES,
    payload: videoCategories,
  };
};
